import { v4 as uuidv4 } from 'uuid';

export const filterEmailData = (selectValues, updateEmails) => {
  const baseData = selectValues[0].value === 'noreply@jotform.com'
    ? selectValues.slice(0, 1)
    : selectValues;

  const formatted = baseData.map(({ name, value }) => ({
    id: uuidv4(),
    name,
    value
  }));

  return [...formatted, ...updateEmails];
};
